/**
 * Calcula o valor futuro de investimentos
 * @param {number} rate - Taxa de juros por período
 * @param {number} nper - Número de períodos
 * @param {number} pmt - Pagamento por período
 * @param {number} pv - Valor presente
 * @param {number} type - Tipo de pagamento (0 = fim do período, 1 = início do período)
 * @returns {number}
 */
export const calculateFutureValue = (rate, nper, pmt, pv, type) => {
  const r = rate;
  let fv;
  
  if (r === 0) {
    fv = -1 * (pv + (pmt * nper));
  } else {
    const term = Math.pow(1 + r, nper);
    if (type === 1) {
      fv = -1 * (pv * term + pmt * (1 + r) * (term - 1) / r);
    } else {
      fv = -1 * (pv * term + pmt * (term - 1) / r);
    }
  }
  
  return fv;
};

/**
 * Formata valores monetários em Real (BRL)
 * @param {number} value 
 * @returns {string}
 */
export const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    maximumFractionDigits: 2
  }).format(value);
};

/**
 * Formata números para exibição compacta
 * @param {number} value 
 * @returns {string}
 */
export const formatCompactNumber = (value) => {
  return new Intl.NumberFormat('pt-BR', {
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: 1
  }).format(value);
};
